var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-select',{attrs:{"value-field":"key","text-field":"label","data-test":"language-select","value":_vm.value,"options":_vm.languages},on:{"input":_vm.changeValue}})}
var staticRenderFns = []

export { render, staticRenderFns }